import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import {BsModalRef} from "ngx-bootstrap/modal";
import { AlertBannerService, AlertType } from 'src/app/lib/alert-banner';
import { SurveyService } from 'src/app/services/survey/survey.service';
import {ConstantsService} from "../../../../services/constants/constants.service";
import { PermissionsService } from 'src/app/services/permissions/permissions.service';


@Component({
  selector: 'app-replace-reference-modal',
  templateUrl: './replace-reference-modal.component.pug',
  styleUrls: ['./replace-reference-modal.component.scss'],
  standalone: false
})
export class ReplaceReferenceModalComponent implements OnInit {

  reasons = ConstantsService.REFEREE_REPLACE_REASONS;

  selectedReasonValue = '';
  selectedReasonId = -1;
  @Input() refereeId;
  @Input() checkId = 0;
  @Output() referenceReplaceStatus = new EventEmitter();

  constructor(public _bsModalRef: BsModalRef,
              private surveyService: SurveyService,
              private alertList: AlertBannerService,
              private permissions: PermissionsService
              ) { }

  ngOnInit(): void {
    this.reasons[4].value = $localize`Candidate offering an additional referee`;
  }

  closeModal() {
    this._bsModalRef.hide();
  }

  onSelectChange(reason: any) {
    this.selectedReasonValue = reason.value;
    this.selectedReasonId = reason.id;
  }

  submit() {
      if (this.selectedReasonId > 0) {
          this.surveyService.addReplaceRefereeDetails(this.checkId, this.refereeId, this.selectedReasonId)
            .subscribe(
              () => {
                this.closeModal();
                this.alertList.append([{
                  active: true,
                  type: AlertType.SUCCESS,
                  message: 'Success! A replacement reference has been requested.'
                }]);
                this.referenceReplaceStatus.emit('Success');
              },
              () => {
                this.closeModal();
                this.alertList.append([{
                  active: true,
                  type: AlertType.DANGER,
                  message: 'Oops! Something went wrong. Our developers have been notified. Feel free to try again.'
                }]);
                this.referenceReplaceStatus.emit('Failure');
              }
            );

      } else {
        console.log("Selected reason is not a valid value: ", this.selectedReasonId);
      }
  }

}
